import ImportCsvDialog from "./ImportCsvDialog";

interface Props {
  importOpen: boolean;
  onCloseImport: () => void;
  importPath: string;
  importRevenueOpen: boolean;
  onCloseImportRevenue: () => void;
  importRevenuePath: string;
  channelName: string;
  writableMonths: string[];
  fileStem: string;
}

// The quantity and revenue CSV import dialogs on the By Month edit page.
// Both take the Export CSV shape (a `type` column, one MM/YY column per
// month, a qty row and a revenue row per product); each importer reads only
// its own rows.
export default function ByMonthImportDialogs({
  importOpen,
  onCloseImport,
  importPath,
  importRevenueOpen,
  onCloseImportRevenue,
  importRevenuePath,
  channelName,
  writableMonths,
  fileStem,
}: Props) {
  return (
    <>
      <ImportCsvDialog
        open={importOpen}
        onClose={onCloseImport}
        importPath={importPath}
        title="Import By Month CSV"
        description={`Upload a CSV to bulk-update planned units per product × month for ${channelName}.`}
        valuesHint="whole units; thousands separators are fine; blank cells leave the existing value unchanged — only explicit numbers (including 0) are written."
        rowType="qty"
        writableMonths={writableMonths}
        fileStem={fileStem}
      />
      <ImportCsvDialog
        open={importRevenueOpen}
        onClose={onCloseImportRevenue}
        importPath={importRevenuePath}
        title="Import Revenue CSV"
        description={`Upload a CSV to bulk-update planned revenue per product × month for ${channelName}. Each amount is converted to units using that product's Average Selling Price.`}
        valuesHint="revenue amounts; thousands separators are fine; each amount is divided by the product's Average Selling Price and rounded to the nearest unit. Products with no Average Selling Price set on this channel are skipped and reported. Blank cells leave the existing value unchanged."
        rowType="revenue"
        writableMonths={writableMonths}
        fileStem={fileStem}
      />
    </>
  );
}
